export const sendConversionEvent = (transactionId, value = 30.0, currency = "USD") => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-11378036298/66mACNrrtJwaEMqcvLEq",
        value: value,
        currency: currency,
        transaction_id: transactionId || "", // Pass dynamic transaction ID
      });
    }
  };